/**
 * Lazy route registration for the positions feature (Plan 02-06 — dashboard
 * only; Plan 02-07 owns wizard + detail).
 *
 * Pairs with the i18n ``bindI18n`` + ``preload`` config in ``lib/i18n.ts`` so
 * the dashboard's positions / common namespaces render in the right language
 * on first navigation (BUG-003).
 */
import { lazy } from "react";

export const PositionTilesDashboardRoute = lazy(() =>
  import("@/features/positions/PositionTilesDashboard").then((m) => ({
    default: m.PositionTilesDashboard,
  })),
);
